import { AxiosResponse } from 'axios';
import { API_URL_AUTH } from '@/commons/config';

import FileReader from '@/util/fileReader';
import GlobalStore from '@/store/modules/global';
import AuthenticationService from '@/services/authentication.service';
import { router } from '@/router';

function iscpvRoute(name?: string) {
  return typeof name === 'string' && name.startsWith('cpv');
}
import TransportadoraAuthService from '@/services/transportadora.auth.service';

export const handleResponse = (response: any) => {
  const { data: result, config } = response;
  const { name } = router.currentRoute;

  if ([401, 403].find(status => status === response.status)) {
    AuthenticationService.logout();
    const { name } = router.currentRoute;
    if (
      name === 'criar-solicitacao' ||
      name === 'solicitacoes' ||
      name === 'detalhamento' ||
      name === 'lotes'
    )
      AuthenticationService.logoutSiePedidos(true);

    if (name === 'lote') AuthenticationService.logoutSiePedidos(false);

    return Promise.reject(result);
  }

  if (config.url.includes('graphql')) {
    const { data, errors } = result;

    if (errors) {
      return handleGraphqlErrorResponse(errors, result);
    }

    return data;
  }

  return result;
};

const handleGraphqlErrorResponse = (errors: any, result: any) => {
  GlobalStore.setSnackBar({
    message: errors[0].message || errors[0].exception.message || errors[0].message,
    show: true,
    type: 'error',
  });

  return Promise.reject(result);
};

export const handleErrorResponse = async (error: any) => {
  const config = error?.config;
  const response = error?.response;
  const data = response?.data;
  const { path, name, fullPath } = router.currentRoute;

  if (config?.skipGlobalErrorHandler) {
    return Promise.reject(error);
  }

  let message =
    data?.detail ||
    data?.message ||
    data?.mensagem ||
    data?.error ||
    error?.message ||
    'Ocorreu uma falha ao processar a requisição';

  if (path === '/vaivem/consulta-cpf') {
    return Promise.reject(error);
  }

  if (!response) {
    GlobalStore.setSnackBar({
      show: true,
      type: 'error',
      message,
    });

    return Promise.reject(error);
  }

  if (isFileType(error)) {
    message = (await getMessageFromFileType(data)) || message;
  }

  if (path === '/vaivem/confirmar-entrega/estudante/confirma') {
    return Promise.reject(error);
  }

  if (config?.url === API_URL_AUTH && (response.status === 401 || response.status === 400)) {
    message = 'Credenciais inválidas, verifique as informações e tente novamente';

    GlobalStore.setSnackBar({ show: true, type: 'error', message });
    AuthenticationService.logout();

    if (
      path === '/carteira-macrorregiao/entidade/' ||
      path === '/carteira-macrorregiao/entidade/solicitacoes' ||
      path === '/carteira-macrorregiao/entidade/detalhamento' ||
      path === '/carteira-macrorregiao/entidade/lotes'
    )
      AuthenticationService.logoutSiePedidos(true);

    if (path === '/carteira-macrorregiao/grafica/lote') {
      AuthenticationService.logoutSiePedidos(false);
    }
  } else if (response.status === 401) {
    GlobalStore.setSnackBar({ show: true, type: 'error', message });

    if (
      path === '/carteira-macrorregiao/entidade/' ||
      path === '/carteira-macrorregiao/entidade/solicitacoes' ||
      path === '/carteira-macrorregiao/entidade/detalhamento' ||
      path === '/carteira-macrorregiao/entidade/lotes'
    )
      AuthenticationService.logoutSiePedidos(true);

    if (path === '/carteira-macrorregiao/grafica/lote') {
      AuthenticationService.logoutSiePedidos(false);
    }
  } else {
    GlobalStore.setSnackBar({ show: true, type: 'error', message });
  }

  return Promise.reject(error);
};

const isFileType = (error: any) =>
  error.request.responseType === 'blob' &&
  error.response.data instanceof Blob &&
  error.response.data.type &&
  error.response.data.type.toLowerCase().indexOf('json') != -1;

const getMessageFromFileType = async (data: any): Promise<string> => {
  const file = await FileReader(data);
  const { message } = JSON.parse(file);

  return message;
};
